import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { darken } from 'polished';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Button as CoreButton } from '@finect/tabular-core/Button';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1eiij3v-0"
})(["display:flex;align-items:center;margin-top:24px;margin-bottom:24px;padding:16px 24px;border:1px solid ", ";border-radius:", ";box-shadow:", " 0 0 0 2px;", ""], function (_ref) {
  var theme = _ref.theme,
    $borderColor = _ref.$borderColor;
  return $borderColor ? $borderColor : theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme,
    $borderColor = _ref3.$borderColor;
  return $borderColor ? $borderColor : theme.colors.ui;
}, function (_ref4) {
  var bottomMargin = _ref4.bottomMargin;
  return bottomMargin ? 'margin-bottom: 64px;' : '';
});
export var Container = styled.div.withConfig({
  displayName: "partials__Container",
  componentId: "sc-1eiij3v-1"
})(["", " ", " > div > h4{color:", ";}> button{background-color:", ";}> button:not(:disabled):hover{background-color:", ";}"], minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: 8fr 1fr;\n    align-items: center;\n    "]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n\n    :first-child {\n      width: 100%;\n    } \n  "]))), function (_ref5) {
  var theme = _ref5.theme,
    $color = _ref5.$color;
  return $color || theme.colors.primary;
}, function (_ref6) {
  var theme = _ref6.theme,
    $colorCTA = _ref6.$colorCTA;
  return $colorCTA || theme.colors.font;
}, function (_ref7) {
  var theme = _ref7.theme,
    $colorCTA = _ref7.$colorCTA;
  return darken(0.1, $colorCTA || theme.colors.font);
});
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-1eiij3v-2"
})(["", " h4{font-weight:700;", " color:", ";}p{", " color:black;}"], minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["width: 90%;"]))), getFont(1), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, getFont(-1));
export var Button = styled(CoreButton).withConfig({
  displayName: "partials__Button",
  componentId: "sc-1eiij3v-3"
})(["display:flex;align-items:center;", " span{margin-right:16px;font-weight:700;", "}"], maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 24px;\n  width: fit-content;\n  "]))), getFont(-1, 'compact'));